import { h } from 'preact';
import Page from 'components/pages/page.js';
import { Link } from 'components/core/link/link.js';
import Cta from 'components/pages/home/cta/cta.js';
import Follow from 'components/shared/follow/follow.js';
import Carousel from 'components/shared/carousel/carousel.js';
import Countdown from 'components/shared/countdown/countdown';
import HTML from 'components/core/html/html';
import * as transitionStates from 'components/core/transition/transitionStates.js';
import { accessNested, condClass, joinClasses, getStylingImagePath } from 'utils/utils';
import { getSizeBasedTT } from 'utils/clientUtils';
import { useDynamicAssetFolder, IMAGE_REGION_ROOT_DYNAMIC } from 'utils/assets';
import pure from 'utils/pure';
import s from 'components/pages/home/home.sss';
import ClosableTrailer from 'components/shared/closableTrailer/closableTrailer.js';
// import SimpleVideoPlayer from "components/shared/simpleVideoPlayer/simpleVideoPlayer";
// import Youtube from "components/shared/youtube/youtube.js";
// import Store from 'store/store';

export default @pure class Home extends Page {
	//////////////////
	// LIFECYCLE /////
	//////////////////

	constructor() {
		super();
		this.state = {
			trailerClosed: false,
			isDelayComplete: false
		};
	}

	componentDidMount() {
		super.componentDidMount();

		if (typeof window !== 'undefined') {
			if (typeof window.firstSessionVisit == 'undefined') {
				window.firstSessionVisit = true;
			} else {
				window.firstSessionVisit = false;
			}
		}
		// Below was a fix for preact showing incorrect images when reusing component
		// Probably fixed now, but not 100% so leaving this comment
		// if (this.$tt) {
		// 	let src = this.$tt.src;
		// 	this.$tt.removeAttribute('src');
		// 	this.$tt.setAttribute('src', src);
		// }

		const { closableTrailer } = this.props.pageData;
		const delayMs = closableTrailer && closableTrailer.delay ? closableTrailer.delay * 1000 : 0;
		this.delayTrailer = setTimeout(() => {
			this.setState({ isDelayComplete: true });
		}, delayMs);
	}

	componentWillUnmount() {
		clearTimeout(this.delayTrailer);
	}

	//////////////////
	// FUNCTIONS /////
	//////////////////

	sizeBasedTT(data) {
		const img = getSizeBasedTT(data, this.props.client);
		const imgNoExtension = img.split('.')[0];
		const imgRoot = IMAGE_REGION_ROOT_DYNAMIC;
		const ttPath = getStylingImagePath(this.props.appData, imgNoExtension, imgRoot + '/' + img);
		return useDynamicAssetFolder(ttPath);
	}

	getTitleTreatment(copy, imageRoot, pageData) {
		let props = this.props || {};
		copy = copy || props.appData.copy;
		imageRoot = imageRoot || IMAGE_REGION_ROOT_DYNAMIC;
		pageData = pageData || props.pageData;
		let src = this.sizeBasedTT(pageData && pageData.alternateTT);
		let img = (
			<h1 class={s.titleText} id="titleText">
				<img
					ref={e => (this.$tt = e)}
					alt={copy.$HOME_TITLE_TREATMENT_SEO || 'Movie title'}
					class={s.title}
					src={src}
				/>
				<span>{copy.$HOME_TITLE_TREATMENT_SEO}</span>
			</h1>
		);
		if (pageData && pageData.ttLinkOut) {
			// Why do we wrap it in an extra div ?
			return (
				<div class={s.homeTTLinkOut}>
					<Link href={pageData.ttLinkOut} target="_blank" trackId="home-tt-link-out">
						{img}
					</Link>
				</div>
			);
		}
		return img;
	}

	getOfficialWebsiteButton() {
		let officialSite = accessNested(this.props, 'pageData.officialSiteLink');
		if (!officialSite) return;
		let officialSiteCopy = accessNested(this.props, 'appData.copy.$OFFICIAL_WEBSITE');
		return (
			<div class={s.officialSiteContainer}>
				<Link
					target="_blank"
					class={s.officialSite}
					href={officialSite}
					trackId="home-official-website"
				>
					{officialSiteCopy}
				</Link>
			</div>
		);
	}

	getExtraContent() { }

	// For any elements that need to be position fixed or absolute, the transform from the parent makes this impossible so this allows them to sit outside of it
	getExtraContentOutside() { }

	///////////////////////
	// RENDER METHODS /////
	///////////////////////

	renderCarousel(carousel) {
		const mediaRoot = this.props.appData.urls.roots.imageRegion;
		const slides = carousel.items;
		const transition = carousel.transition;
		const slideDuration = carousel.slideDuration;
		const slideDelay = carousel.slideDelay;
		const showProgressIcons = carousel.showProgressIcons;

		return (
			<Carousel
				mediaRoot={`${mediaRoot}/carousel`}
				carouselClass={s.carousel}
				slides={slides}
				transition={transition}
				slideDuration={slideDuration}
				slideDelay={slideDelay}
				showProgressIcons={showProgressIcons}
				autoSlide
				appData={this.props.appData}
				showtimes={this.props.showtimes}
			/>
		);
	}

	renderCTAs(buttonClass) {
		const { pageData, appData, activePage, showtimes, client } = this.props;
		const extraHomeCta = pageData.extraHomeCta;
		const { copy } = appData;
		const sharedImageRoot = appData.urls.roots.sharedImages;
		const appUrl = appData.meta.url;

		const releaseDate = appData.options.useBoxOfficeCalendar && appData.meta.dates.boxOffice
			? appData.meta.dates.boxOffice
			: appData.meta.dates.release;
		const retVal = [
			<Cta
				appData={appData}
				releaseDate={releaseDate}
				copy={copy}
				client={client}
				class={buttonClass}
				sharedImageRoot={sharedImageRoot}
				pageData={pageData}
				appUrl={appUrl}
				showtimesStatus={showtimes.status}
				activePage={activePage}
				useMessengerRemind={appData.options.useMessengerRemind}
				key="cta"
			/>
		];

		if (extraHomeCta) {
			retVal.push(
				<Cta
					appData={appData}
					releaseDate={releaseDate}
					copy={copy}
					extraHomeCta
					client={client}
					class={buttonClass}
					sharedImageRoot={sharedImageRoot}
					pageData={pageData}
					appUrl={appUrl}
					showtimesStatus={showtimes.status}
					activePage={activePage}
					key="extraCta"
				/>
			);
		}

		return retVal;
	}

	render({ pageData, appData, transitionState, showtimes, client, user, activePage }) {
		const {
			copy,
			styling
		} = appData;

		const {
			colorFollowIcons
		} = styling;

		// const { deviceSize, device } = client;
		// const imageRegionRoot = appData.urls.roots.imageRegion;
		// const sharedImageRoot = appData.urls.roots.sharedImages;

		// const releaseDate = appData.meta.dates.boxOffice
		// const scrollingSite = appData.options.scrollingSite;
		const carouselData = pageData.carousel;
		// const ttPosition = pageData.TTpositions;

		let buttonClass = s.cta;
		let wrapperClass = joinClasses(s.contentWrapper, showtimes.status && s.live);
		let followData = pageData.follow;

		let inTransition = false;
		switch (transitionState) {
			case transitionStates.STATE_CHILD_ENTERING:
			case transitionStates.STATE_CHILD_LEAVING:
				inTransition = true;
				wrapperClass = s.contentWrapperTransition;
				buttonClass = s.ctaTransition;
				break;
		}

		let firstTimeHome = true;
		if (typeof window != 'undefined') {
			firstTimeHome = window.firstSessionVisit;
		}

		const {
			isFirstVisit = true
		} = user;
		let {
			closableTrailer = {},
			closingTrailer = {}, // deprecated - remove if you see this still here after september 2018
			customDesktopUI = false,
			trailerOverlayConstant = true, // will load the closableTrailer on page load
			trailerOverlayOnPageChange = false, // will load the closableTrailer after navigating away from and back to the home page
			ctaExtraText = false
		} = pageData;

		//support 'closingTrailer' for now so that everything doesn't break - remove if you see this still here after september 2018
		closableTrailer = Object.keys(closableTrailer).length > 0 ? closableTrailer : closingTrailer;

		const {
			ytid = '',
			closeText = '',
			overlayText = '',
			src: closingSrc = '',
			vimeoID = '',
			showTT,
			disableForGoogleBot
		} = closableTrailer;

		let showClosableTrailer = !!pageData.closableTrailer || !!pageData.closingTrailer;
		if (!isFirstVisit && !trailerOverlayConstant) {
			showClosableTrailer = false;
		}
		if (!firstTimeHome && !trailerOverlayOnPageChange) {
			showClosableTrailer = false;
		}
		try {
			if (disableForGoogleBot && /Googlebot/i.test(navigator.userAgent)) {
				showClosableTrailer = false;
			}
		} catch (e) {}

		let countdownTimezone = pageData.countdownTimezone || accessNested(this.props, 'appData.meta.dates.timezoneOffsetFromUTC');
		const { isDelayComplete } = this.state;

		return (
			<div class={joinClasses(s.wholePage + condClass(inTransition, s.transition))}>
				{!!carouselData && this.renderCarousel(carouselData)}
				{showClosableTrailer && isDelayComplete && (
					<ClosableTrailer
						imgRoot={accessNested(appData, 'urls.roots.imageRegion')}
						ytid={ytid}
						vimeoID={vimeoID}
						closeText={closeText}
						overlayText={overlayText}
						showTT={showTT}
						src={closingSrc}
						customDesktopUI={customDesktopUI}
						client={client}
						activePage={activePage}
					/>
				)}
				<div class={wrapperClass} key="wrapper">
					<div class={s.upperPlayer} />
					<div class={s.marketingContent}>
						{this.getTitleTreatment(copy, IMAGE_REGION_ROOT_DYNAMIC, pageData)}
						{ctaExtraText && (
							<HTML markdown class={s.ctaExtraText}>
								{copy.$CTA_EXTRA_TEXT}
							</HTML>
						)}
						{this.renderCTAs(buttonClass)}
						<div class={s.followWrapper}>
							<Follow
								followClass={s.follow}
								followData={followData}
								iconShade={accessNested(appData, 'styling.socialIconShade', 'light')}
								socialData={appData.meta.social}
								copy={copy}
								color={colorFollowIcons}
							/>
							{this.getOfficialWebsiteButton()}
						</div>
						{pageData.$touts && (
							<ul class={s.toutList}>
								{pageData.$touts.map(tout => (
									<li class={s.tout}>
										<Link href={tout.path} target={tout.newWindow ? '_blank' : '_self'}>
											{tout.text}
										</Link>
									</li>
								))}
							</ul>
						)}
						{this.getExtraContent()}
					</div>
				</div>
				{pageData.countdownDate && (
					<Countdown
						timeOffset={countdownTimezone}
						date={pageData.countdownDate}
						hideLabels={pageData.hideCountdownLabels}
						copy={pageData.countdownCopy}
					/>
				)}
				{this.getExtraContentOutside()}
			</div>
		);
	}
}

export const dependencies = {
	showtimes: true,
	user: true
};
